import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-button-loader',
  templateUrl: './button-loader.component.html',
  styleUrls: ['./button-loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ButtonLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
